<template>
    <div class="home">
    </div>
  </template>
  
  <script>
  import { onMounted, reactive } from 'vue'
  import { useRouter } from "vue-router";
  
  export default {
      setup() {
          const router = useRouter();
          const comp = reactive({
              data : "",
              login: () => {
                //   router.push({path: "/login"});
              }
          });
  
          onMounted(() => {
              // Mounted
              router.push({path: "/Front/List"});
  
          });
  
          return {comp};
      }
  }
  </script>
  